import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListDepartmentPage = loadable(() => import('./ListDepartmentPage'), {
    fallback: <Loader/>,
});
const AddDepartmentPage = loadable(() => import('./AddDepartmentPage'), {
    fallback: <Loader/>,
});
const EditDepartmentPage = loadable(() => import('./EditDepartmentPage'), {
    fallback: <Loader/>,
});
const DepartmentRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListDepartmentPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddDepartmentPage t={t} alert={alert} />} />
      <Route exact path="edit/:id" element={<EditDepartmentPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
DepartmentRoute.propTypes = {
  t: PropTypes.func
};
export default DepartmentRoute;
